import accents from 'remove-accents'

export function localeIncludes (string, search) {
  const clearString = accents.remove(string || '').toLowerCase()
  const clearSearch = accents.remove(search || '').toLowerCase()
  return clearString.includes(clearSearch)
}
